import { Routes } from '@angular/router';
import { notFoundGuard } from './core/guards/not-found-guard';

export const routes: Routes = [
    {
        path: 'profile-error',
        loadComponent: () =>
            import('./features/system/profile-error/profile-error')
                .then(m => m.ProfileError),
    },
    {
        path: 'forbidden',
        loadComponent: () =>
            import('./features/system/forbidden/forbidden')
                .then(m => m.Forbidden),
    },
    {
        path: 'tracking',
        loadComponent: () =>
            import('./features/public/tracking/tracking')
                .then(m => m.Tracking),
    },
    {
        path: 'tracking/:code',
        loadComponent: () =>
            import('./features/public/tracking/tracking')
                .then(m => m.Tracking),
    },

    {
        path: '',
        loadChildren: () =>
            import('./features/dashboard/dashboard.routes')
                .then(m => m.dashboardRoutes),
    },

    {
        path: '',
        loadChildren: () =>
            import('./back-office-shell.routes')
                .then(m => m.backOfficeShellRoutes),
    },
    {
        path: 'driver',
        loadChildren: () =>
            import('./driver-shell.routes')
                .then(m => m.driverShellRoutes),
    },
    {
        path: 'warehouse',
        loadChildren: () =>
            import('./warehouse-shell.routes')
                .then(m => m.warehouseShellRoutes),
    },
    {
        path: '**',
        canMatch: [notFoundGuard],
        loadComponent: () =>
            import('./features/system/not-found/not-found')
                .then(m => m.NotFound),
    },
];
